// Import page-specific classes
import { IndexPage } from './pages/index.js';
import { ElixirPage } from './pages/elixir.js';

// Immediately add class to prevent flickering as soon as script loads
document.body.classList.add('js-loaded');

// Determine which page we're on and initialize appropriate class
function initializePage() {
  const path = window.location.pathname;

  if (path.includes('elixir')) {
    new ElixirPage();
  } else {
    // Default to index page
    new IndexPage();
  }
}

// Initialize when DOM is loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializePage);
} else {
  initializePage();
}